import { useFeature } from "@hackler/react-sdk";

/**
 * 2026 추석 연휴(9/23 21:00 ~ 9/28 09:00) 콜 차단 스위치.
 *
 * platform, ssr-platform 의 같은 이름 훅과 한 세트다. 배포 단위가 달라 파일은 나누되
 * 플래그 키와 FORCE 값은 항상 같이 맞춘다. 한쪽만 켜지면 도메인별로 화면이 갈린다.
 *
 * 이 도메인은 platform 과 달리 헤더를 통째로 숨기지 않는다. parlor 의 헤더 Nav 자체가
 * 시설탐색이라, 장례비용만 남기고 시설 메뉴를 빼는 쪽이 도메인 성격에 맞는다.
 */

/**
 * 핵클 기능 플래그 키. ON 이면 차단이다.
 *
 * 운영에서는 이 앱이 www.goifuneral.co.kr 과 같은 SDK 키를 쓴다(양쪽 _app 번들에서 확인).
 * 그래서 30 번 하나만 켜면 두 도메인이 같이 걸린다.
 *
 * 다만 dev 는 한동안 키가 갈려 있어 parlor 만 차단이 안 걸렸다. 한쪽 도메인에서만
 * 차단이 안 보이면 플래그가 아니라 그 앱의 SDK 키 환경변수부터 확인한다.
 */
const CHUSEOK_2026_FEATURE_KEY: number | null = 30;

/** 핵클 없이 강제로 켜는 스위치. 연휴에 핵클이 안 먹으면 이 줄만 true 로 바꿔 배포한다. */
const CHUSEOK_2026_FORCE = false;

export const useChuseokOff = (): boolean => {
  /** 훅은 조건부 호출이 안 되므로 키가 없을 때도 호출은 하되 결과를 무시한다. */
  const featureOn = useFeature(CHUSEOK_2026_FEATURE_KEY ?? 0);

  if (CHUSEOK_2026_FORCE) return true;
  if (CHUSEOK_2026_FEATURE_KEY === null) return false;

  return featureOn;
};
